import {
  ChartSmsParam,
  DashboardFilters,
  SmsMetrics,
} from '@/services/dashboard-service/dashboard.service.types';
import { calculateSecondsToMinutes } from '@/utils/helpers';
import styles from './sms-metric.module.scss';
import dayjs from 'dayjs';

export const calculateDateForXAxis = (
  time_range: DashboardFilters['time_range'],
  date: SmsMetrics['chart'][0]['date'],
  start_time?: DashboardFilters['start_time'],
  end_time?: DashboardFilters['end_time']
) => {
  const parsedDate = dayjs(date);
  const startDate = start_time ? dayjs(start_time) : null;
  const endDate = end_time ? dayjs(end_time) : null;
  const isSingleOrTwoDayRange = startDate && endDate && endDate.diff(startDate, 'days') <= 1;

  if (time_range === '24h' || isSingleOrTwoDayRange) {
    return parsedDate.format('h A');
  }

  return parsedDate.format('D MMM');
};

export const createSmsMetricCardsData = (smsMetrics?: SmsMetrics) => {
  if (!smsMetrics) {
    return [];
  }

  const getArrowColorClass = (change: number, isReverse = false) => {
    return !isReverse
      ? change > 0
        ? styles.increase
        : styles.decrease
      : change > 0
        ? styles.decrease
        : styles.increase;
  };

  return [
    {
      title: 'AI Resolution Rate',
      tooltipContent:
        'Percentage of sms that were resolved by the AI without needing to be transferred to a human agent.',
      currentPercent: `${Math.round(smsMetrics.ai_resolution.current_percent)}%`,
      change: smsMetrics.ai_resolution.change,
      sms: String(smsMetrics.ai_resolution.value),
      description: 'sms resolved by AI',
      arrowColor: getArrowColorClass(smsMetrics.ai_resolution.change),
      chartParam: 'ai_resolution' as ChartSmsParam,
    },
    {
      title: 'Agent Handoff Rate',
      tooltipContent: 'Percentage of sms that were transferred from AI to human agents.',
      currentPercent: `${Math.round(smsMetrics.agent_handoff.current_percent)}%`,
      change: smsMetrics.agent_handoff.change,
      sms: String(smsMetrics.agent_handoff.value),
      description: 'sms handed off to agents',
      arrowColor: getArrowColorClass(smsMetrics.agent_handoff.change, true),
      chartParam: 'agent_handoff' as ChartSmsParam,
    },
    {
      title: 'Average Speed of Answer (ASA)',
      tooltipContent:
        'Average time (in minutes) it takes for a sms to be answered by an AI or agent.',
      currentPercent: calculateSecondsToMinutes(smsMetrics.asa.value),
      change: smsMetrics.asa.change,
      sms: '',
      description: '(minutes:seconds)',
      arrowColor: getArrowColorClass(smsMetrics.asa.change, true),
      chartParam: 'asa' as ChartSmsParam,
    },
  ];
};
